'use strict';

var debounce = require('lodash/debounce');
var backToTopButton = $('.back-to-top');

$(window).on('scroll', debounce(function () {
    if ($(this).scrollTop()) {
        backToTopButton.fadeIn();
    } else {
        backToTopButton.fadeOut();
    }
}, 10));
